import React, { useState } from 'react';
import bankMaster from '../MasterJson/bank_master.json';

const BankSelect = ({ onSelect, onIfscChange, ifscInput }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedBank, setSelectedBank] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);

  const filteredBanks = bankMaster.filter(bank =>
    bank.bank_name.toLowerCase().includes(searchTerm.toLowerCase())
  );


  const handleBankSelect = (bank) => {
    setSelectedBank(bank);
    setSearchTerm('');
    setShowDropdown(false);
    if (onSelect) {
      onSelect(bank);
    }
    if (onIfscChange) {
      onIfscChange({ target: { value: bank.ifsc_code_sample || '' } });
    }
  };

  // const handleInputChange = (e) => {
  //   setSearchTerm(e.target.value);
  //   setShowDropdown(true);
  // };
  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setShowDropdown(value.length > 0);
  };

  return (
    <div className="w-full">
      <label className="block text-sm font-medium text-gray-700 mb-1">Search Bank</label>
      <input
        type="text"
        placeholder="Type bank name..."
        value={searchTerm}
        onChange={handleInputChange}
        className="w-full px-4 py-4 text-lg border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200 mb-3"
      />
      {/* {showDropdown && filteredBanks.length > 0 && (
        <div className="max-h-48 overflow-y-auto border border-gray-200 rounded-md mb-4">
          {filteredBanks.map((bank, idx) => (
            <div
              key={idx}
              onClick={() => handleBankSelect(bank)}
              className={`px-3 py-2 cursor-pointer hover:bg-blue-100 ${
                selectedBank?.bank_code === bank.bank_code ? 'bg-blue-50 font-semibold' : ''
              }`}
            >
              {bank.bank_name}
            </div>
          ))}
        </div>
      )} */}
      {showDropdown && searchTerm.length > 0 && filteredBanks.length > 0 && (
        <div className="max-h-48 overflow-y-auto border border-gray-200 rounded-md mb-4">
          {filteredBanks.map((bank, idx) => (
            <div
              key={idx}
              onClick={() => handleBankSelect(bank)}
              className={`px-4 py-4 text-lg cursor-pointer hover:bg-blue-100 ${selectedBank?.bank_code === bank.bank_code
                ? 'bg-blue-50 font-semibold'
                : ''
                }`}
            >
              {bank.bank_name}
            </div>
          ))}
        </div>
      )}

      {/* {showDropdown && filteredBanks.length === 0 && (
        <div className="px-3 py-2 text-gray-500 italic">No banks found</div>
      )} */}
      {showDropdown && searchTerm.length > 0 && filteredBanks.length === 0 && (
        <div className="px-4 py-4 text-lg text-gray-500 italic">
          No banks found
        </div>
      )}

      {selectedBank && (
        <div className="space-y-3">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Bank Name</label>
            <input
              type="text"
              value={selectedBank.bank_name}
              readOnly
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200 mb-3"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Enter IFSC Code</label>
            <input
              type="text"
              value={ifscInput}
              onChange={(e) => onIfscChange(e)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
            />
          </div>

          <div className="text-sm text-gray-800 space-y-1">
            {/* <p><strong>Bank Code:</strong> {selectedBank.bank_code}</p>
            <p><strong>IFSC Prefix:</strong> {selectedBank.ifsc_prefix}</p> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default BankSelect;
